import { cn } from '@/utilities/ui'
import { ImageGalleryCard } from './card/card'
import { Fragment } from 'react'
import RichText from '@/components/RichText'

const GalleryBlock2 = (props: any) => {
  const { title, subtitle, eyebrow, images } = props

  const firstTwoImages = images.slice(0, 2)
  const otherImages = images.slice(2)

  return (
    <section className="container mx-auto py-10" aria-label="Gallery">
      <header className="flex flex-col items-center justify-center">
        {eyebrow && (
          <div className="border border-primary px-4 py-1 rounded-full mb-2 w-fit flex items-center justify-center">
            <span className="text-primary">
              <RichText data={eyebrow} enableGutter={false} enableProse={false} />
            </span>
          </div>
        )}
        {title && (
          <span
            className={cn(
              'text-xl font-semibold md:text-4xl lg:text-5xl text-center mb-3 md:mb-4 lg:mb-6',
            )}
          >
            <RichText data={title} enableGutter={false} enableProse={false} />
          </span>
        )}
        {subtitle && (
          <span
            className={cn('mb-8 text-muted-foreground lg:text-lg max-w-3xl mx-auto text-center')}
          >
            <RichText data={subtitle} enableGutter={false} enableProse={false} />
          </span>
        )}
      </header>
      <ul className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <li>
          <ImageGalleryCard {...firstTwoImages[0]} />
        </li>
        <li className="md:col-span-2">
          <ImageGalleryCard {...firstTwoImages[1]} />
        </li>
      </ul>
      <ul className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {otherImages.map((image: any, index: any) => (
          <li key={index}>
            <ImageGalleryCard {...image} />
          </li>
        ))}
      </ul>
    </section>
  )
}

export default GalleryBlock2
